$rise_devtools_selector_overlay $mol_view
	active false
	rpc_port \
	rect null
	target_id? \
	target_name \
	target_attrs? /
	target_info null
	selected? false
	visible false
	sub <= content /
	Panel $mol_view
		sub <= panel_content /
		style *
			^
			top <= panel_top \100%
			bottom <= panel_bottom \auto
			maxWidth <= panel_max_width \none
			maxHeight <= panel_max_height \none
			overflow \auto
	Label $mol_view
		sub /
			<= Title $mol_view
				sub /
					<= target_title \
	Files $rise_devtools_selector_overlay_files
		target_info <= target_info null
		rpc_port <= rpc_port \
	style *
		^
		display <= display \none
		left <= left_px \0px
		top <= top_px \0px
		width <= width_px \0px
		height <= height_px \0px
		pointerEvents <= pointer_events \none
